import { useQueryClient } from '@tanstack/react-query';

/**
 * Хук для управления кэшем контент-плана
 * Предоставляет функции для инвалидации кэша после мутаций
 */
export const useContentPlanCache = () => {
  const queryClient = useQueryClient();

  /**
   * Инвалидирует все кэши, связанные с контент-планом
   * Используется после операций, которые могут изменить данные контент-плана
   */
  const invalidateContentPlanData = (contentPlanId?: string) => {
    console.log('🔄 [CACHE] Начинаем инвалидацию кэша для contentPlanId:', contentPlanId);
    
    // Показываем все существующие ключи кэша
    const cache = queryClient.getQueryCache();
    const allQueries = cache.getAll();
    console.log('📋 [CACHE] Все существующие ключи кэша:');
    allQueries.forEach((q: any, index: number) => {
      console.log(`  ${index + 1}.`, q.queryKey, 'state:', q.state.status, 'data:', q.state.data ? 'exists' : 'null');
    });
    
    // Проверяем конкретно наш ключ
    const ourQuery = queryClient.getQueryData(['content-plan', contentPlanId]);
    console.log('🔍 [CACHE] Наш ключ кэша:', ['content-plan', contentPlanId], 'данные:', ourQuery ? 'exists' : 'null');
    
    // Инвалидируем конкретный контент-план если ID указан
    if (contentPlanId) {
      console.log('🔄 [CACHE] Инвалидируем конкретный контент-план:', contentPlanId);
      queryClient.invalidateQueries({ 
        queryKey: ['content-plan', contentPlanId] 
      });
    }

    // Инвалидируем все запросы контент-планов (для случаев, когда ID не указан)
    console.log('🔄 [CACHE] Инвалидируем все запросы контент-планов');
    queryClient.invalidateQueries({ 
      queryKey: ['content-plan'] 
    });
    
    console.log('✅ [CACHE] Инвалидация кэша завершена');
  };

  /**
   * Принудительно обновляет данные контент-плана с сервера
   */
  const refetchContentPlan = (contentPlanId: string) => {
    return queryClient.refetchQueries({ 
      queryKey: ['content-plan', contentPlanId] 
    });
  };

  /**
   * Очищает весь кэш контент-планов (используется в крайних случаях)
   */
  const clearContentPlanCache = () => {
    queryClient.removeQueries({ 
      queryKey: ['content-plan'] 
    });
  };

  return {
    invalidateContentPlanData,
    refetchContentPlan,
    clearContentPlanCache
  };
};
